export default __webpack_public_path__ + "static/m-service-4-3ab7219eed963f15853e5f7ee4fd39b2.jpg";